module.exports = __webpack_public_path__ + "img/mob-bottom2.87818dd9.png";